import $ from 'jquery';

$(document).ready(function() {
  var items = $("[data-update-btn-id]");

  $.each(items, function(index, value) {
    var cb_id = $(value).data('update-btn-id');

    $('#chbox-' + cb_id).click(function() {
      var el = $('#update-btn-' + cb_id);
      el.toggleClass('hidden');
    });
  });
});
